import { render, staticRenderFns } from "./AppLayoutV2.vue?vue&type=template&id=0627cc74&scoped=true"
import script from "./AppLayoutV2.vue?vue&type=script&lang=js"
export * from "./AppLayoutV2.vue?vue&type=script&lang=js"
import style0 from "./AppLayoutV2.vue?vue&type=style&index=0&id=0627cc74&prod&lang=css"
import style1 from "./AppLayoutV2.vue?vue&type=style&index=1&id=0627cc74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0627cc74",
  null
  
)

export default component.exports